// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Admin } from './admin';
import { Counterparty } from './counterparty';
import { CurrencyType } from './currency-type';
import { SubEntry } from './sub-entry';
import { TransferLiability } from './transfer-liability';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Liability extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  liabilityId!: number;
  accountId!: number;
  adminId!: number;
  bankAccountId?: number;
  counterpartyId!: number;
  createdBy!: string;
  createdDate!: Date;
  currencyTypeId?: number;
  entryId?: number;
  exFlags?: number;
  flags?: number;
  isPaid!: boolean;
  liabilityDate!: Date;
  liabilityDueDate?: Date;
  liabilityValue!: number;
  memo?: string;
  purchaseOrderId?: number;
  reference?: string;
  securityId?: number;
  totalPaid!: number;
  ts!: string;
  type?: number;
  uid?: string;
  updatedBy!: string;
  updatedDate!: Date;
  account!: Account;
  admin!: Admin;
  bankAccount!: Account;
  counterparty!: Counterparty;
  currencyType!: CurrencyType;
  inversePurchaseOrder!: Liability[];
  purchaseOrder!: Liability;
  subEntries!: SubEntry[];
  transferLiabilities!: TransferLiability[];
}

